module.exports = __webpack_public_path__ + "static/media/swirepayconnect.32cb21aa.png";